module.exports = "pegasus/assets/blocks/column-9-theme3.png";